import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";

export const BlueOutlineButton = styled(Button)`
  && {
    background: transparent;
    color: ${colours.elexonBlue};
    border: 1px solid ${colours.elexonBlue};
    box-shadow: unset;
    padding: 0.6rem 1.9rem;
    height: 2.5rem;
    transition: all 0.3s;
    width: 10rem;

    &.auto-width {
      width: auto;
    }

    &:hover {
      background-color: ${colours.elexonBlue};
      color: ${colours.white};
    }

    &:disabled {
      background-color: transparent;
      border: 1px solid ${colours.mediumGrey};
      color: ${colours.mediumGrey};
    }
  }
`;
